import { UniversalPicker } from '@rainbow-modules/forms';
import styled, { css } from 'styled-components';
import { color } from 'theme';
import Input from 'components/Input';
import { GREY_800 } from '../../../constants';

export const FieldsContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    height: 100%;
`;

interface StyledRadioItemProps {
    isHover?: boolean;
    isFocused?: boolean;
    isSelected?: boolean;
    disabled?: boolean;
}

export const StyledUniversalPicker = styled(UniversalPicker)`
    width: 100%;

    > div {
        gap: 0.5rem;

        > div {
            margin: 0;
        }
    }
`;

export const StyledRadioItem = styled.span<StyledRadioItemProps>`
    position: relative;
    width: 100%;
    padding: 0.5rem;
    gap: 1rem;
    background-color: white;
    display: flex;
    align-items: start;
`;

export const StyledRadio = styled.span<StyledRadioItemProps>`
    position: relative;
    width: 20px;
    height: 20px;
    padding: 0;
    background: #fff;
    border: solid 2px #dbdade;
    border-radius: 20px;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;
    flex-shrink: 0;

    &::after {
        content: '';
        position: absolute;
        height: 8px;
        width: 8px;
        top: 4px;
        left: 4px;
        background: #fff;
        border-radius: 20px;
        box-sizing: border-box;
    }

    ${(props) => props.isSelected && css`
            background: ${color('brand.main')(props)};
            border: 2px solid;
            border-color: ${color('brand.main')(props)};
            box-shadow: 0px 2px 4px 0px ${color('brand.light')(props)};

            &::after {
                background: #fff;
                box-sizing: border-box;
            }
    `};

    ${(props) => props.isFocused && css`
            background: ${color('brand.main')(props)};
            border: 2px solid;
            border-color: ${color('brand.main')(props)};
            box-shadow: 0px 2px 4px 0px ${color('brand.light')(props)};
    `};

    ${(props) => props.disabled && css`
            background-color: #fff;
            border-color: #dbdade;

            &::after {
                background: #fff;
                box-sizing: border-box;
            }
    `};
`;

export const StyledInput = styled(Input)`
    margin-top: 0.5rem;

    label {
        margin-left: 0rem;
    }
`;

export const StyledPickerOptionContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin-left: 0.85rem;
`;

export const StyledOptionLabel = styled.span`
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3125rem;
    color: ${GREY_800};
`;
